/**
 * Smart scroll for nav buttons on product pages with a pinned hero + slide-up reveal.
 * Sections live inside a position:fixed wrapper that's translateY(100vh) until the
 * spacer is fully scrolled. So scrollIntoView won't work while still in the hero.
 *
 * Strategy: if we're not yet past the spacer, first scroll the window past it so the
 * reveal completes, then scrollIntoView the target after the layout settles.
 */
export const scrollToHashTarget = (href: string) => {
  const target = document.querySelector(href) as HTMLElement | null;
  if (!target) return;

  const spacer = document.querySelector('[data-hero-spacer]') as HTMLElement | null;
  if (spacer && window.scrollY < spacer.offsetHeight - 10) {
    window.scrollTo({ top: spacer.offsetHeight, behavior: 'smooth' });
    // Wait for the slide-up transition to settle, then scroll inside the revealed area.
    window.setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 850);
  } else {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
